<template>
	<div class="bookmarks-page page" flat>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<v-card-text v-else-if="isBlocked !== null">
			<v-skeleton-loader
				style="max-width: 555px"
				v-bind="attrs"
				type="card"
				v-if="isLoading"
			/>
			<div v-else>
				<BookmarkList v-if="bookmarksList.length > 0" :resourcesItems="bookmarks" />
				<div v-if="!isLoading && bookmarksList.length <= 0" class="mt-5 align-center">
					<NewsFeedEmpty
						title="Bookmarks is empty at the moment."
						description="Check back later."
					/>
				</div>
				<div
					class="d-flex mt-5 mb-2 ma-auto justify-center home-page__pagination"
					v-if="!isLoading && bookmarksList.length > 0"
				>
					<Pagination
						:page="filters.page"
						:pageCount="pageCount"
						v-on:pageChange="onPageChange"
					/>
				</div>
			</div>
		</v-card-text>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/images/search.svg'
import BookmarkList from '@/components/Profile/BookmarkList.vue'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'

export default {
	name: 'ProfileBookmarksPage',
	mixins: [Block],
	components: {
		NewsFeedEmpty,
		BookmarkList,
		Pagination,
		PageBlocked,
	},
	computed: {
		...mapGetters('profile', ['bookmarks', 'bookmarksMeta', 'isLoading']),
		...mapGetters('auth', ['profile']),
		...mapGetters('settings', ['appCore']),

		bookmarksList() {
			if (this.bookmarks.length <= 0) {
				return []
			}

			return this.bookmarks
		},
		pageCount() {
			if (!this.bookmarksMeta) {
				return 0
			}

			return +this.bookmarksMeta.pageCount
		},
	},
	methods: {
		...mapActions('profile', ['getProfileBookmarks', 'clearBookmarks']),
		...mapActions('app', ['setPageTitle']),

		onPageChange(page) {
			if (this.filters.page !== page) {
				const params = {
					search: this.filters.search,
					page: page,
				}
				this.filters.page = page
				const queryString = this.formatFilters(params)
				this.getResources(queryString)
			}
		},
		getResources(queryString) {
			this.getProfileBookmarks(queryString)
		},
		filterSearch(e) {
			clearTimeout(this.timer)

			const params = {
				search: e.target.value,
				page: 1,
			}
			this.filters.page = 1
			const queryString = this.formatFilters(params)

			this.timer = setTimeout(() => {
				this.getResources(queryString)
			}, 500)
		},
		formatFilters(filters) {
			const { search, page } = filters

			let queryString = `page=${page}`

			if (search !== undefined && search.length > 0) {
				queryString += `&search=${search}`
			}

			return queryString
		},
	},
	data() {
		return {
			searchIcon,
			successMessage: false,
			errorMessage: false,
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
				search: '',
			},
			pageBlockedName: 'profile',
		}
	},
	mounted() {
		this.setPageTitle('Bookmarks')
	},
	created() {
		if (!this.isBlocked) !this.bookmarks.length && this.getProfileBookmarks()
	},
	beforeDestroy() {
		this.clearBookmarks()
	},
}
</script>

<style lang="scss">
.bookmarks-page {
	border-radius: 8px !important;
	margin-bottom: 30px;
	max-width: 555px;
	width: 100%;
	background-color: transparent !important;
	font-family: 'Inter', sans-serif;

	@media (max-width: 768px) {
		margin-bottom: 12px;
	}

	&__header {
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
		align-items: center;

		@media (max-width: 480px) {
			flex-direction: column;
			align-items: flex-start;
		}
	}

	&__search-wrapper {
		@media (max-width: 480px) {
			margin-top: 12px;
		}
	}

	&__title {
		font-size: 24px;
		font-weight: 700;
		line-height: 29.26px;
		color: #4a4a4a;
	}

	@media screen and (max-width: 960px) {
		.bookmarks-page__title {
			font-size: 25px !important;
		}
	}
	@media screen and (max-width: 600px) {
		.v-card__text {
			padding: 0;
		}
	}
}
</style>
